<template>
  <el-dialog
    :visible.sync="submitDialog"
    title="Are you sure you want to submit this plan?"
    :before-close="cancel"
    v-loading="isSaving"
  >
    <el-row :gutter="10">
      <el-col
        :xs="24"
        :sm="20"
        :md="20"
        :lg="17"
        class="center-block"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          label-width="130px"
        >
          <el-form-item
            label="To Status: "
            prop="approvalStatus"
          >
            <el-select
              v-model="form.approvalStatus"
              placeholder="Status"
              @change="getRole"
            >
              <el-option
                v-for="(item,index) in data.selectStatus"
                :key="index"
                :label="item.displayName"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Action By Role: ">
            <el-select
              v-model="roleList.displayName"
              disabled
              placeholder="Role"
            >
              <el-option
                v-for="(item, index) in roleList"
                :key="index"
                :label="item.displayName"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="decision"
            label="Load Decision: "
            prop="loadDecision"
          >
            <el-select
              v-model="form.loadDecision"
              placeholder="Load Decision"
            >
              <el-option
                v-for="(item, index) in this.GLOBAL.loadDecision"
                :key="index"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="user"
            label="Action By User: "
            prop="approvalUserID"
          >
            <el-select
              v-model="form.approvalUserID"
              placeholder="User"
            >
              <el-option
                v-for="(item, index) in userList"
                :key="index"
                :label="item.displayName"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Upload File: ">
            <el-upload
              ref="upload"
              class="el-btn-upload"
              :on-change="handleChange"
              :auto-upload="false"
              action="www.com"
              :multiple="false"
              :fileList="fileList"
            >
              <el-button
                type="primary"
                slot="trigger"
              >
                <i class="el-icon-upload el-icon--left"></i>
                File Upload
              </el-button>
            </el-upload>
          </el-form-item>
          <el-form-item label="Comments: ">
            <el-input
              type="textarea"
              :rows="3"
              v-model="form.approvalComments"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetForm('form')">Cancel</el-button>
            <el-button
              type="primary"
              @click="submitUpload('form')"
            >Submit</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </el-dialog>
</template>
<script>
import { getUserByRoleIdCountry } from "@/api/user";
import { postApproval } from "@/api/mine";
import { uploadLocalFile } from "@/utils/azure";
import { Message } from "element-ui";
export default {
  name: "SubmitBox",
  props: {
    result: {
      type: Boolean
    },
    data: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      isSaving: false,
      fileList: [],
      upload: {
        link: this.GLOBAL.uploadLink.shipment,
        upLoadData: {
          UserId: sessionStorage.getItem("userID")
        },
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("token")}`
        },
        showFileList: true,
        fileList: []
      },
      submitDialog: this.result,
      roleList: {
        displayName: "",
        value: ""
      },
      user: true,
      decision: false,
      userList: [],
      form: {
        planID: sessionStorage.getItem("planID"),
        roleID: "",
        approvalUserID: "",
        approvalStatus: "",
        approvalComments: "",
        fileID: "",
        createUserID: sessionStorage.getItem("userID"),
        loadDecision: ""
      },
      rules: {
        approvalStatus: [
          {
            required: true,
            message: "Please choose a To Status.",
            trigger: "change"
          }
        ],
        loadDecision: [
          {
            required: true,
            message: "Please choose a Loading Decision.",
            trigger: "change"
          }
        ],
        approvalUserID: [
          {
            required: true,
            message: "Please choose the next Plan Owner.",
            trigger: "change"
          }
        ]
      }
    };
  },
  watch: {
    result (val) {
      this.submitDialog = val;
    }
  },
  methods: {
    handleChange (file, fileList) {
      let fileName = file.name;
      let fileType =
        fileName &&
        (fileName.includes(".txt") ||
          fileName.includes(".pdf") ||
          fileName.includes(".xlsx") ||
          fileName.includes(".docx") ||
          fileName.includes(".doc") ||
          fileName.includes(".xls") ||
          fileName.includes(".ppt") ||
          fileName.includes(".pptx") ||
          fileName.includes(".zip"));
      if (!fileType) {
        Message.error({
          message:
            "Only accept the following file types: .txt, .pdf, .xls, .xlsx, .doc, .docx, .ppt, .pptx, .zip"
        });
        this.fileList =
          this.fileList && this.fileList.length > 0 ? [this.fileList[0]] : [];
        return false;
      }
      this.fileList =
        fileType && fileList && fileList.length > 1 ? [fileList[1]] : fileList;
    },
    getUser (id) {
      this.form.roleID = this.roleList.value;
      this.userList = [];
      const country = sessionStorage.getItem("planCountry");
      getUserByRoleIdCountry(id, country).then(res => {
        res.data.forEach(element => {
          this.userList.push({
            displayName: element.userName,
            value: element.userID
          });
        });
      });
    },
    getRole (val) {
      this.user = true;
      this.decision = false;
      switch (val) {
        case 1:
          this.roleList.value = "a18fbc37-253a-11e9-9d85-00155d4b0103";
          this.roleList.displayName = "MP";
          this.getUser(this.roleList.value);
          break;
        case 2:
          this.roleList.value = "9915544a-253a-11e9-9d85-00155d4b0103";
          this.roleList.displayName = "Brand Team";
          this.getUser(this.roleList.value);

          break;
        case 3:
          this.roleList.value = "d8b58280-253a-11e9-9d85-00155d4b0103";
          this.roleList.displayName = "DP";
          this.getUser(this.roleList.value);
          break;
        case 4:
          this.roleList.value = "a18fbc37-253a-11e9-9d85-00155d4b0103";
          this.roleList.displayName = "MP";

          this.getUser(this.roleList.value);
          break;
        case 5:
          this.roleList.value = "a18fbc37-253a-11e9-9d85-00155d4b0103";
          this.roleList.displayName = "MP";
          this.getUser(this.roleList.value);
          this.user = false;
          this.decision = true;
          this.form.approvalUserID = "";
        default:
          break;
      }
    },
    cancel () {
      this.$emit("dialogData", false);
    },
    resetForm (formName) {
      this.userList = [];
      this.$refs[formName].resetFields();
      this.$emit("dialogData", false);
    },
    postApprovalFun (fileID = "") {
      if (this.data.valid) {
        let params = this.form;
        params = fileID > "" ? { ...params, fileID } : { ...params };
        postApproval(params).then(res => {
          if (res.data.success) {
            this.$message({
              message: "Submitted successfully.",
              type: "success"
            });
            this.$emit("dialogData", false);
            this.isSaving = false;
            setTimeout(() => {
              this.$router.push({
                name: this.data.redirect
              });
            }, 500);
          } else {
            this.$confirm(
              "Submit is not successful, please submit again",
              "Alert",
              {
                confirmButtonText: "Confirm",
                cancelButtonText: "Cancel",
                type: "warning",
                center: true
              }
            )
              .then(() => {
                this.$emit("dialogData", true);
                this.resetForm(formName);
                this.isSaving = false;
              })
              .catch(() => {
                this.$emit("dialogData", false);
                this.isSaving = false;
              });
          }
        });
      } else {
        this.$message({
          message: "Plan components cannot be all empty.",
          type: "error",
          showClose: true,
          duration: 5000
        });
        this.isSaving = false;
      }
    },
    submitUpload (formName) {
      this.$refs[formName].validate(valid => {
        if (valid && this.fileList && this.fileList.length > 0) {
          this.isSaving = true;
          uploadLocalFile(this.fileList[0])
            .then(res => {
              console.log(res.name);
              if (res && res.name > "") {
                let fileID = res.name;
                this.postApprovalFun(fileID);
              } else {
                this.$message({
                  message: "Failed to upload.",
                  type: "error",
                  showClose: true,
                  duration: 5000
                });
                this.isSaving = false;
              }
            })
            .catch(err => {
              this.isSaving = false;
            });
        } else if (valid) {
          this.isSaving = true;
          this.postApprovalFun();
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SubmitBox/index.vue